document.addEventListener("DOMContentLoaded", function () {
  const pincodeInput = document.getElementById("pincode-input");
  const checkButton = document.getElementById("check-pincode-btn");
  const messageEl = document.getElementById("pincode-error-message");

  if (checkButton) {
  checkButton.addEventListener("click", () => {
    const enteredPincode = pincodeInput.value.trim();

    if (enteredPincode.length !== 6 || isNaN(enteredPincode)) {
      showMessage("Please enter a valid 6-digit pincode.", "inherit");
      return;
    }
    if (window.serviceablePincodes.includes(enteredPincode)) {
      showMessage("Delivery available at this pincode!", "green");
    } else {
      showMessage("Sorry, delivery is not available at this pincode.", "inherit");
    }
  });
  }

  function showMessage(text, color) {
    const formErrorWrapper = document.querySelector('.product-form__error-message-wrapper');
    const formErrorMessage = formErrorWrapper ? formErrorWrapper.querySelector('.product-form__error-message') : null;
  
    if (formErrorWrapper && formErrorMessage) {
      formErrorWrapper.hidden = false;
      formErrorMessage.textContent = text;
      formErrorMessage.style.color = color;
    }
  }
});
